<template>
  <Row :gutter="16">
    <Col span="24">
      <div style="margin: auto; padding: 10px 0;">
        <Input v-model="queryStr" placeholder="请输入关键词查询" @on-change="fetchData"></Input>
      </div>
      <Card span="24" v-for="study in studys" class="select-study-item"
      @click.native="redirect(study.id)" :key="study.id">
        {{ study.abbreviation }} {{ study.code }}
      </Card>
      <pagination v-bind:meta="pageMeta" name="pagination"
      v-if="pageMeta.pageCount > 1" @refresh="fetchData"></pagination>
    </Col>
  </Row>
</template>

<script>
import { FetchMineStudy } from '@/api/study'
// import { FetchAuth } from '@/api/auth'
import Pagination from '@/components/share/Pagination'

export default {
  name: 'list-studys',
  data: function () {
    return {
      studys: [],
      queryStr: '',
      pageMeta: {}
    }
  },
  components: {
    'pagination': Pagination
  },
  methods: {
    fetchData: function (page = 1) {
      var query = this.$router.currentRoute.query
      query['page'] = page
      query['queryStr'] = this.queryStr
      FetchMineStudy(query).then(async res => {
        this.studys = res.items
        this.pageMeta = res._meta
      })
    },
    redirect: function (id) {
      var root = this.$route.matched[0].path
      root = root === '/study/:id' ? '/study' : root
      sessionStorage.setItem('studyid', id)
      this.$router.push(root + '/' + id)
      this.$emit('closeModal')
      // FetchAuth({ id: id }).then(async res => {
      //   this.$store.dispatch('refreshAuth', res)
      // })
    }
  }
}
</script>

<style>
.select-study-item {
  cursor: pointer;
}
</style>
